import { invoicesConstants } from "../constants/invoicesConstants";
import { invoicesService } from "../../services/API/invoicesService";
import { history } from "../store/configureStore";

export const invoicesActions = {
  getInvoicesData,
  getInvoicesList,
  getPaidInvoicesList,
  getAllInvoicesList,
  deleteInvoices,
  getInvoicesDetails,
  executeInvoices,
  getSiteList,
  resendInvoices,
};

function getInvoicesData() {
  return dispatch => {
    dispatch(request());
    invoicesService.getInvoicesList().then(
      invoices => {
        dispatch(success(invoices));
      },
      error => {
        dispatch(failure("getInvoicesData error: " + error.toString()));
      }
    );
  };

  function request(invoices) {
    return { type: invoicesConstants.FETCH_INVOICES_REQUEST, invoices };
  }
  function success(invoices) {
    return { type: invoicesConstants.FETCH_INVOICES_SUCCESS, invoices };
  }
  function failure(error) {
    return { type: invoicesConstants.FETCH_INVOICES_FAILURE, error };
  }
}

export const addInvoices = postData => {
  return dispatch => {
    dispatch(request());
    invoicesService.addInvoices(postData).then(
      invoices => {
        dispatch(success(invoices));
        history.push("/invoices");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(invoices) {
    return { type: invoicesConstants.ADD_INVOICES_REQUEST, invoices };
  }
  function success(invoices) {
    return { type: invoicesConstants.ADD_INVOICES_SUCCESS, invoices };
  }
  function failure(error) {
    return { type: invoicesConstants.ADD_INVOICES_FAILURE, error };
  }
};

export const getInvoicesList = formData => {
  return dispatch => {
    dispatch(request());
    invoicesService.getInvoicesList(formData).then(
      invoices => {
        dispatch(success(invoices));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(invoices) {
    return { type: invoicesConstants.FETCH_INVOICES_REQUEST, invoices };
  }
  function success(invoices) {
    return { type: invoicesConstants.FETCH_INVOICES_SUCCESS, invoices };
  }
  function failure(error) {
    return { type: invoicesConstants.FETCH_INVOICES_FAILURE, error };
  }
};

export const getPaidInvoicesList = formData => {
  return dispatch => {
    dispatch(request());
    invoicesService.getPaidInvoicesList(formData).then(
      invoices => {
        dispatch(success(invoices));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(invoices) {
    return { type: invoicesConstants.FETCH_INVOICES_REQUEST, invoices };
  }
  function success(invoices) {
    return { type: invoicesConstants.FETCH_INVOICES_SUCCESS, invoices };
  }
  function failure(error) {
    return { type: invoicesConstants.FETCH_INVOICES_FAILURE, error };
  }
};

export const getAllInvoicesList = formData => {
  return dispatch => {
    dispatch(request());
    invoicesService.getAllInvoicesList(formData).then(
      invoices => {
        dispatch(success(invoices));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(invoices) {
    return { type: invoicesConstants.FETCH_ALLINVOICES_REQUEST, invoices };
  }
  function success(invoices) {
    return { type: invoicesConstants.FETCH_ALLINVOICES_SUCCESS, invoices };
  }
  function failure(error) {
    return { type: invoicesConstants.FETCH_ALLINVOICES_FAILURE, error };
  }
};

export const deleteInvoices = invoicesIdASParams => {
  return dispatch => {
    dispatch(request());
    invoicesService.deleteInvoices(invoicesIdASParams).then(
      invoices => {
        dispatch(success(invoices));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(invoices) {
    return { type: invoicesConstants.DELETE_INVOICES_REQUEST, invoices };
  }
  function success(invoices) {
    return { type: invoicesConstants.DELETE_INVOICES_SUCCESS, invoices };
  }
  function failure(error) {
    return { type: invoicesConstants.DELETE_INVOICES_FAILURE, error };
  }
};

export const executeInvoices = postData => {
  return dispatch => {
    dispatch(request());
    invoicesService.executeInvoices(postData).then(
      invoices => {
        dispatch(success(invoices));
        history.push("/invoices");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(invoices) {
    return { type: invoicesConstants.EXECUTE_INVOICES_REQUEST, invoices };
  }
  function success(invoices) {
    return { type: invoicesConstants.EXECUTE_INVOICES_SUCCESS, invoices };
  }
  function failure(error) {
    return { type: invoicesConstants.EXECUTE_INVOICES_FAILURE, error };
  }
};

export const getInvoicesDetails = invoicesIdParams => {
  return dispatch => {
    dispatch(request());
    invoicesService.getInvoicesDetails(invoicesIdParams).then(
      invoicesDetails => {
        dispatch(success(invoicesDetails));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(invoicesDetails) {
    return { type: invoicesConstants.GET_INVOICES_DETAILS_REQUEST, invoicesDetails };
  }
  function success(invoicesDetails) {
    return { type: invoicesConstants.GET_INVOICES_DETAILS_SUCCESS, invoicesDetails };
  }
  function failure(error) {
    return { type: invoicesConstants.GET_INVOICES_DETAILS_FAILURE, error };
  }
};

export const updateInvoices = postData => {
  return dispatch => {
    dispatch(request());
    invoicesService.updateInvoices(postData).then(
      updatedInvoices => {
        dispatch(success(updatedInvoices));
        history.push("/invoices");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(updatedInvoices) {
    return { type: invoicesConstants.UPDATE_INVOICES_REQUEST, updatedInvoices };
  }
  function success(updatedInvoices) {
    return { type: invoicesConstants.UPDATE_INVOICES_SUCCESS, updatedInvoices };
  }
  function failure(error) {
    return { type: invoicesConstants.UPDATE_INVOICES_FAILURE, error };
  }
};

export const getSiteList = (page) => {
  return dispatch => {
    dispatch(request());
    invoicesService.get_SiteList(page).then(
      sitelist => {
        dispatch(success(sitelist));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(sitelist) {
    return { type: invoicesConstants.FETCH_SITELIST_REQUEST, sitelist };
  }
  function success(sitelist) {
    return { type: invoicesConstants.FETCH_SITELIST_SUCCESS, sitelist };
  }
  function failure(error) {
    return { type: invoicesConstants.FETCH_SITELIST_FAILURE, error };
  }
};

export const get_site_details_id = siteIdParams => {
  return dispatch => {
    dispatch(request());
    invoicesService.get_site_details_id(siteIdParams).then(
      sitedata => {
        dispatch(success(sitedata));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(sitedata) {
    return { type: invoicesConstants.GET_SITE_DETAILS_REQUEST, sitedata };
  }
  function success(sitedata) {
    return { type: invoicesConstants.GET_SITE_DETAILS_SUCCESS, sitedata };
  }
  function failure(error) {
    return { type: invoicesConstants.GET_SITE_DETAILS_FAILURE, error };
  }
};

export const removeChildInvoices = invoicesIdAsParams => {
  return dispatch => {
    invoicesService.removeChildInvoices(invoicesIdAsParams).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: invoicesConstants.DELETE_INVOICES_REQUEST, data };
  }
  function success(data) {
    return { type: invoicesConstants.DELETE_INVOICES_SUCCESS, data };
  }
  function failure(error) {
    return { type: invoicesConstants.DELETE_INVOICES_FAILURE, error };
  }
};

export const resendInvoices = postData => {
  return dispatch => {
    invoicesService.resendInvoices(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: invoicesConstants.POST_RESEND_REQUEST, data };
  }
  function success(data) {
    return { type: invoicesConstants.POST_RESEND_SUCCESS, data };
  }
  function failure(error) {
    return { type: invoicesConstants.POST_RESEND_FAILURE, error };
  }
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/invoicesActions.js